import { gsap } from 'gsap';

export default class Header {
    constructor() {
        this.elements = {
            target: document.querySelector('.js-header'),
            menu: document.querySelector('.js-menu'),
            menuTriggers: document.querySelectorAll('.js-toggle-menu'),
        };

        this.elements.menuItemsWithChildren = this.elements.menu.querySelectorAll('.nav__item.has--dropdown');

        this.settings = {
            delta: 5,
            trigger: 10,
            menuState: false,
        };

        this.headerFixed = false;
        this.lastScrollTop = 0;
        this.isDocumentReady = false;
        this.breakpoint = 768;
        this.isAnimation = false;

        // Bind this to functions
        this.togglemenu = this.togglemenu.bind(this);
        this.onScroll = this.onScroll.bind(this);

        if (this.elements.target) {
            this.targetHeight = this.elements.target.offsetHeight;

            this.setDOMReferences();
        }
    }

    setDOMReferences() {
        if (this.elements.menu && this.elements.menuTriggers.length) {
            for (let i = 0; i < this.elements.menuTriggers.length; i++) {
                const element = this.elements.menuTriggers[i];
                element.addEventListener('click', this.togglemenu);
            }
        }

        if (this.elements.menuItemsWithChildren.length) {
            for (let i = 0; i < this.elements.menuItemsWithChildren.length; i++) {
                const element = this.elements.menuItemsWithChildren[i];
                const trigger = element.querySelector('.js-dropdown-trigger');

                if (trigger) {
                    trigger.addEventListener('click', () => {
                        console.log('toggle item');
                        if (element.classList.contains('is--open')) {
                            element.classList.remove('is--open');
                        } else {
                            element.classList.add('is--open');
                        }
                    });
                }
            }
        }

        window.addEventListener('scroll', this.onScroll);
        window.addEventListener('resize', this.onResize);
    }

    togglemenu() {
        if (this.settings.menuState) {
            this.settings.menuState = false;
        } else {
            this.settings.menuState = true;
        }

        if (this.settings.menuState) {
            // show menu
            const tl = gsap.timeline();
            tl.set(this.elements.menu, { pointerEvents: 'all', visibility: 'visible', x: 0 });
            tl.to(this.elements.menu, { autoAlpha: 1, duration: 0.15 });
            tl.fromTo(this.elements.menu.querySelectorAll('.nav--menu .nav__item'),
                { autoAlpha: 0, y: 12 },
                {
                    autoAlpha: 1,
                    y: 0,
                    stagger: {
                        each: 0.03,
                        from: 'left',
                    },
                    duration: 0.2,
                });
        } else {
            // hide menu
            const tl = gsap.timeline();
            tl.to(this.elements.menu, { autoAlpha: 0, duration: 0.15 });
            tl.set(this.elements.menu, { pointerEvents: 'none', visibility: 'hidden', x: '100%' });
        }
    }

    onTimelineStart() {
        this.isAnimation = true;
    }

    onTimelineComplete(fixed) {
        this.isAnimation = false;
        this.headerFixed = fixed;
    }

    onScroll() {
        if (this.isAnimation) {
            return;
        }

        const st = window.pageYOffset || document.documentElement.scrollTop;
        const vw = document.documentElement.clientWidth;

        if (Math.abs(st - this.lastScrollTop) <= this.settings.delta) {
            return;
        }

        // Check small header
        if (st < this.settings.trigger && this.headerFixed === true) {
            let logoSize = '13.3rem';
            let mainNavigationMargin = '3.6rem';
            if (vw < this.breakpoint) {
                mainNavigationMargin = '0rem';
                logoSize = '6.65rem';
            }

            const tl = gsap.timeline({
                onStart: () => this.onTimelineStart(),
                onComplete: () => this.onTimelineComplete(false),
            });
            tl.to(this.elements.target.querySelector('.header__inner'), { autoAlpha: 0, duration: 0.2 });
            tl.to(this.elements.target.querySelector('.header__background'), { y: '-100%', duration: 0.2 });
            tl.set(this.elements.target.querySelector('.header__inner'), { alignItems: 'flex-start' });
            if (this.elements.target.querySelector('.header__breadcrumbs')) {
                tl.set(this.elements.target.querySelector('.header__breadcrumbs'), { autoAlpha: 1, display: 'flex' });
            }
            tl.set(this.elements.target.querySelector('.header__main-navigation'), { marginBottom: mainNavigationMargin });
            tl.set(this.elements.target, { position: 'absolute', padding: '2.4rem 0 1.2rem 0' });
            tl.set(this.elements.target.querySelector('.logo'), { width: logoSize, height: logoSize });
            tl.to(this.elements.target.querySelector('.header__inner'), { autoAlpha: 1, duration: 0.2 });
            
            document.querySelector('header').classList.remove('sticky');

        } else if (this.headerFixed === false) {
            
            document.querySelector('header').classList.add('sticky');

            const tl = gsap.timeline({
                onStart: this.onTimelineStart(),
                onComplete: this.onTimelineComplete(true),
            });
            tl.to(this.elements.target.querySelector('.header__inner'), { autoAlpha: 0, duration: 0.2 });
            tl.set(this.elements.target.querySelector('.header__inner'), { alignItems: 'center' });
            if (this.elements.target.querySelector('.header__breadcrumbs')) {
                tl.set(this.elements.target.querySelector('.header__breadcrumbs'), { autoAlpha: 0, display: 'none' });
            }
            tl.set(this.elements.target.querySelector('.header__main-navigation'), { marginBottom: '0rem' });
            tl.set(this.elements.target, { position: 'fixed', padding: '1.2rem 0' });
            tl.set(this.elements.target.querySelector('.logo'), { width: '6rem', height: '6rem' });
            tl.to(this.elements.target.querySelector('.header__background'), { y: 0, duration: 0.2 });
            tl.to(this.elements.target.querySelector('.header__inner'), { autoAlpha: 1, duration: 0.2 });
        }

        this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }
}
